// extracted by css-extract-rspack-plugin
export default {"name":"GQSrhv"};